import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_SM, SV_TRANSITION} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: SV_RADIUS_SM,
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: '18px',
        letterSpacing: 0,
        whiteSpace: 'nowrap',
        transition: SV_TRANSITION,
        '.lightTheme &': {
            color: '#1F262B',
        },
        '.darkTheme &': {
            color: SV_DARK.text,
        },
        '&:hover': {
            cursor: 'pointer',
            '.lightTheme &': {
                color: '#0F1416',
                backgroundColor: 'rgba(30, 42, 50, 0.06)',
            },
            '.darkTheme &': {
                color: SV_DARK.text,
                backgroundColor: 'rgba(255, 255, 255, 0.06)',
            },
        },
        '&:active': {
            transform: 'scale(0.97)',
        },
        '&.active': {
            fontWeight: 600,
            '.lightTheme &, .lightTheme &:hover': {
                color: SV_LIGHT.accentText,
                backgroundColor: 'transparent',
            },
            '.darkTheme &, .darkTheme &:hover': {
                color: SV_DARK.accentText,
                backgroundColor: 'transparent',
            },
        },
        '@media (prefers-reduced-motion: reduce)': {
            '&:active': {transform: 'none'},
        },
    },
    pill: {
        position: 'absolute',
        inset: 0,
        borderRadius: SV_RADIUS_SM,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.accent,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.accent,
        },
    },
    label: {
        position: 'relative',
        zIndex: 1,
        display: 'inline-flex',
    },
    iconRoot: {
        padding: '6px 10px',
    },
    icon: {
        fontSize: '18px',
    }
}
